export default __webpack_public_path__ + "static/media/logoFull.4da9d550.png";